import React from 'react';

const FileSaver = require('file-saver');

const MyFallbackComponent = ({ closeErrorModal, error, componentStack }) => {
  const localDataArr = JSON.parse(localStorage.getItem('sso_err_logs') || '[]');
  const localDataTxt = localDataArr.map(item => {
    return `
      api: ${item.api}
      params: ${item.params}
      data: ${item.result}
    `;
  }).join('\n');

  const logMessage = `Error:\n${error.toString()}。\n\ncomponentStack:\n${componentStack}。\n\nFetchData:\n${localDataTxt}`;
  const blob = new Blob([logMessage], {type: "text/plain;charset=utf-8"});

  return (
    <div style={{ padding: 40 }}>
      <p><strong>Oops! An error occured!</strong></p>
      <p>Here’s what we know…</p>
      <p><strong>Error: {error.toString()}</strong></p>
      <p style={{ whiteSpace: 'pre-wrap' }}>
        <strong>componentStack:</strong>
        <br />
        {componentStack}
      </p>
      <hr />
      <button onClick={() => FileSaver.saveAs(blob, "kr-sso-errlog.txt")}>下载日志文件</button>
      &nbsp;|&nbsp;
      <button onClick={() => closeErrorModal()}>关闭</button>
    </div>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: '' };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, componentStack: info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <MyFallbackComponent
          closeErrorModal={() => this.setState({ hasError: false })}
          error={this.state.error}
          componentStack={this.state.componentStack}
        />
      );
    }
    return this.props.children; 
  }
}

export default ErrorBoundary;